import { render, staticRenderFns } from "./RestaurantPosStatus.vue?vue&type=template&id=06def0cd"
import script from "./RestaurantPosStatus.vue?vue&type=script&lang=ts"
export * from "./RestaurantPosStatus.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports